import React, { useEffect, useState } from "react";

const Pagination = ({
  count = 0,
  page = 1,
  rowsPerPage = 25,
  onPageChange = () => {},
  onRowsPerPageChange = () => {},
  bordernonee,
  isCompress
}) => {
  const totalPages = Math.max(1, Math.ceil(count / rowsPerPage));
  const startRow = (page - 1) * rowsPerPage + 1;
  const endRow = Math.min(page * rowsPerPage, count);
  const [compress,setCompress]=useState(false);
     const [isMobileView, setIsMobileView] = useState(() => window.innerWidth < 768);
    useEffect(() => {
      const handleResize = () => {
        const mobile = window.innerWidth < 768;
        setIsMobileView(mobile); // Will properly set true/false based on current width
      };
  
      // Set initial value immediately
      handleResize();
  
      // Add event listener
      window.addEventListener('resize', handleResize);
      console.log("ismobileview", isMobileView);
      if(isMobileView){
        setCompress(true);
      }
      // Cleanup
      return () => window.removeEventListener('resize', handleResize);
    }, []);
 

  useEffect(()=>{
 if(isCompress){
    setCompress(true);
  }
  },[isCompress])

  const handlePageClick = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      onPageChange(newPage);
    }
  };

  const PaginationButtons = () => (
    <div className={`flex space-x-1 ${compress ? "justify-center" : ""} mt-4 sm:mt-0`}>
      <button
        onClick={() => handlePageClick(1)}
        disabled={page === 1}
        className={`p-2 rounded-lg ${
          page === 1
            ? "bg-gray-100 text-gray-400 cursor-not-allowed"
            : "bg-white text-gray-700 hover:bg-indigo-50 hover:text-indigo-600"
        } border border-gray-200 transition-colors duration-200`}
      >
        <div className="flex items-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 24 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M15.707 15.707a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 010 1.414z"
              clipRule="evenodd"
            />
            <path
              fillRule="evenodd"
              d="M10.707 15.707a1 1 0 01-1.414 0l-5-5a1 1 0 010-1.414l5-5a1 1 0 111.414 1.414L6.414 10l4.293 4.293a1 1 0 010 1.414z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      </button>

      <button
        onClick={() => handlePageClick(page - 1)}
        disabled={page === 1}
        className={`p-2 rounded-lg ${
          page === 1
            ? "bg-gray-100 text-gray-400 cursor-not-allowed"
            : "bg-white text-gray-700 hover:bg-indigo-50 hover:text-indigo-600"
        } border border-gray-200 transition-colors duration-200`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
            clipRule="evenodd"
          />
        </svg>
      </button>

      {[...Array(Math.min(5, totalPages))].map((_, i) => {
        const pageNum = page > 3 ? page - 3 + i + 1 : i + 1;
        if (pageNum <= totalPages) {
          return (
            <button
              key={pageNum}
              onClick={() => handlePageClick(pageNum)}
              className={`h-9 w-9 flex items-center justify-center rounded-lg ${
                page === pageNum
                  ? "bg-indigo-100 text-indigo-600 border border-indigo-200"
                  : "bg-white text-gray-700 hover:bg-indigo-50 hover:text-indigo-600 border border-gray-200"
              } transition-colors duration-200 text-sm font-medium`}
            >
              {pageNum}
            </button>
          );
        }
        return null;
      })}

      <button
        onClick={() => handlePageClick(page + 1)}
        disabled={page >= totalPages}
        className={`p-2 rounded-lg ${
          page >= totalPages
            ? "bg-gray-100 text-gray-400 cursor-not-allowed"
            : "bg-white text-gray-700 hover:bg-indigo-50 hover:text-indigo-600"
        } border border-gray-200 transition-colors duration-200`}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            clipRule="evenodd"
          />
        </svg>
      </button>

      <button
        onClick={() => handlePageClick(totalPages)}
        disabled={page >= totalPages}
        className={`p-2 rounded-lg ${
          page >= totalPages
            ? "bg-gray-100 text-gray-400 cursor-not-allowed"
            : "bg-white text-gray-700 hover:bg-indigo-50 hover:text-indigo-600"
        } border border-gray-200 transition-colors duration-200`}
      >
        <div className="flex">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
            <path
              fillRule="evenodd"
              d="M11.293 14.707a1 1 0 010-1.414L14.586 10l-3.293-3.293a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      </button>
    </div>
  );


  return (
    <div className={`bg-white/70 p-4 rounded-b-xl border border-gray-100 ${compress ? "" : "h-[50px]"}`}>
      {compress ? (
        <>
          <div className="flex items-center justify-center mb-4">
            <select
              className="bg-white border border-gray-200 text-gray-700 rounded-lg mr-4 p-2 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
              value={rowsPerPage}
              onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
            >
              {[25, 50, 100].map((size) => (
                <option key={size} value={size}>
                  {size} per page
                </option>
              ))}
            </select>
           {count > 0 && <span className="text-sm text-gray-500">
              Showing {startRow} to {endRow} of {count} entries
            </span>}
          </div>
          <PaginationButtons />
        </>
      ) : (
        <div className="flex flex-col sm:flex-row justify-between items-center h-full">
          <div className="flex items-center">
            <select
              className="bg-white border border-gray-200 text-gray-700 rounded-lg mr-4 p-2 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
              value={rowsPerPage}
              onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
            >
              {[25, 50, 100].map((size) => (
                <option key={size} value={size}>
                  {size} per page
                </option>
              ))}
            </select>
            {count > 0 && <span className="text-sm text-gray-500">
              Showing {startRow} to {endRow} of {count} entries
            </span>}
          </div>
          <PaginationButtons />
        </div>
      )}
    </div>
  );
};

export default Pagination;